import { SESSION_APP_CONTEXT, STORAGE_TYPE_LOCAL } from '../config'
import StorageProviderFactory from '../managers/storage_provider_factory'
import AppContext from '../models/app_context'

export const appContextFromResponse = (response) =>
  new AppContext({
    id: response.app_context.business,
    name: response.name,
    logo: response.app_context.logo_light,
  })

export const currentAppContext = (appContextResults) => {
  if (appContextResults) {
    return appContextFromResponse(appContextResults)
  }
  const stored = StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem(SESSION_APP_CONTEXT)
  return stored ? new AppContext(JSON.parse(stored)) : null
}
